import { ReactNode } from "react"

interface Props {
  title: string
  icon: ReactNode
  children: ReactNode
}

export const Card = ({ title, icon, children }: Props) => {
  return (
    <div className="hub-card">
      <div className="hub-card__icon">{icon}</div>
      <div className="hub-card__title">{title}</div>
      <div className="hub-card__description">{children}</div>
    </div>
  )
}
